import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
// components
import { FormProvider, useForm } from 'react-hook-form';

import * as Yup from 'yup';
import { DialogContent, DialogActions, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';

import { TextFieldBase } from '../../../components/inputs/TextFieldBase';
import { withFormController } from '../../../components/hocs/forms';
import CBButton from '../../../components/Buttons/CbButton';
import { PhoneField as PhoneFieldBase } from '../../../components/inputs/PhoneField';
import { Modal } from '../../../components/modals/v2/helpers/v2.modal.helpers';
import { sendAccounting } from '../_services/BillingService';
import { SendAccountingConfirmationConfig } from './SendAccountingConfirmation';

// helpers

const PhoneField = withFormController(PhoneFieldBase);
const TextField = withFormController(TextFieldBase);
const schema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  email: Yup.string().required('Email is required'),
  phone: Yup.string().required('Phone number is required'),
});

const SendToAccounting = ({ classes, close, data }: any) => {
  const defaultValues = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  };

  const { handleSubmit, ...methods } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    formState: { isSubmitting },
  } = methods;

  const onSubmit = (formData: any) => {
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      policyNumber: data.policyNumber,
      policyId: data.policyId,
      amount: data.amount,
      customerEmail: data.customerEmail,
    };
    return sendAccounting({}, payload)
      .then(() => {
        Modal.show(SendAccountingConfirmationConfig, {
          data: {
            first: formData.firstName,
            last: formData.lastName,
            email: formData.email,
            policyNumber: data.policyNumber,
          },
        });
      })
      .catch(console.error.bind(console));
  };

  const handleCancel = () => {
    close();
  };

  return (
    <section className={classes.cardContentContainer}>
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent classes={{ root: classes.container }}>
            <Grid
              container
              justifyContent="left"
              className={classes.inputFields}
            >
              <Grid item md={5}>
                <TextField
                  name="firstName"
                  label="First Name"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item md={5} className={classes.autoCompleteContainer}>
                <TextField
                  name="lastName"
                  label="Last Name"
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              className={classes.inputFields}
            >
              <Grid item md={5}>
                <TextField name="email" label="Email" fullWidth required />
              </Grid>
              <Grid item md={5} className={classes.autoCompleteContainer}>
                <PhoneField
                  name="phone"
                  label="Phone Number"
                  required
                  fullWidth
                  placeholder="(___) ___-____"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CBButton action={handleCancel} styleName="cancel">
              Cancel
            </CBButton>
            <CBButton
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              styleName="ctaButton"
              buttonText="Send"
            />
          </DialogActions>
        </form>
      </FormProvider>
    </section>
  );
};

const styles = {
  container: {
    flex: '1 1 auto',
    padding: '0 5rem 0.5rem 5rem',
    'overflow-y': 'visible',
  },
  inputFields: {
    justifyContent: 'space-around',
  },
};

const StyledSendToAccounting = withStyles(styles)(SendToAccounting);

export default StyledSendToAccounting;

export const SendToAccountingConfig = {
  SendToAccounting: {
    component: StyledSendToAccounting,
    config: {
      title: 'Send to Accounting',
      maxWidth: 'md',
    },
  },
};
